import React, { useState } from 'react';
import BaseSidebarPanel from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/BaseSidebarPanel';
import TextInput from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/inputs/TextInput';
import MultiStylePropertyPanel from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/style-inputs/MultiStylePropertyPanel';
import ShortcodeBlock from './index';
export default function ShortcodeSidebarPanel({ data, setData }) {
    var _e, _t;
    const [, setErrors] = useState(null);
    const updateData = (d) => {
        const res = ShortcodeBlock.schema.safeParse(d);
        if (res.success == true) {
            setData(res.data);
            setErrors(null);
        }
        else {
            setErrors(res.error);
        }
    };
    return (React.createElement(BaseSidebarPanel, { title: "Shortcode block" },
        React.createElement(TextInput, { label: "Content", rows: 5, defaultValue: (_t = (_e = data.props) === null || _e === void 0 ? void 0 : _e.contents) !== null && _t !== void 0 ? _t : '', onChange: (contents) => updateData(Object.assign(Object.assign({}, data), { props: Object.assign(Object.assign({}, data.props), { contents }) })) }),
        React.createElement(MultiStylePropertyPanel, { names: ['color', 'backgroundColor', 'fontFamily', 'fontSize', 'textAlign', 'padding'], value: data.style, onChange: (style) => updateData(Object.assign(Object.assign({}, data), { style })) })));
}
//# sourceMappingURL=ShortcodeSidebarPanel.js.map